import AOS from 'aos';
import Alpine from 'alpinejs'
import tns from './tns';
Alpine.data('tns', tns);

window.isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

// Variables 
// const $d = $(document),
//       $w = $(window);

function aosInit() {
  AOS.init({
    duration: 450,
    once: false,
  });
}

// const swup = new Swup({
//   plugins: [new SwupBodyClassPlugin()]
// }); 

const b = document.querySelector('body');
const burger = document.querySelector('.locations-link');

// Events
document.addEventListener("DOMContentLoaded", init);
// swup.on('contentReplaced', pageChange);

// Start Apline after swup so it works correctly
window.Alpine = Alpine
Alpine.start();


window.addEventListener('scroll', function(e) {
  
  let initials = document.querySelector('.locationsmenu_initials');

  if(!isMobile) {
    if(document.documentElement.scrollTop > 100) {     
      initials.classList.add('show');
    } else {
      initials.classList.remove('show');
    }
  }
});

// Functions 
function l(m) { 
  console.log(m); 
}

function init() {
  l('👍 init');
  menuRollovers();
  aosInit();
  imgCycler();
}

function pageChange() {
  l('swupChange');
  // closeMenu();
  menuRollovers();
}

function menuRollovers() {
  l('menuRollovers');
  let locs = document.querySelectorAll('.locations li');
  let locMenu = document.querySelector('.locationsmenu')
  locs.forEach((el) => {
    el.addEventListener('mouseenter', (loc) => {
      if(locMenu.classList.contains('active')) {
        changeContent(el);
      }
    });
  });
}

function imgCycler() {
  document.querySelectorAll('.cycle').forEach(function(e) {
    let delay = e.dataset.duration;
    if(e.querySelectorAll('.cycle_image').length > 1) {
      setInterval(function() { 
        let $active = e.querySelector('.active');
        let $next = ($active.nextElementSibling) ? $active.nextElementSibling : e.querySelector('.cycle_image:first-child');
        $active.classList.remove('active'); //reset the z-index and unhide the image
        $next.classList.add('active'); //make the next image the top one
      }, delay);
    }
  });
}

function changeContent(el) {
  l('changeContent');
  let index = el.dataset.loc;
  
  // change image
  document.querySelectorAll('.locationsmenu_images div').forEach((img)=> {
    img.classList.remove('active');
    img.classList.add('hidden');
  });
  
  let current = document.querySelector('.locationsmenu_images div[data-loc="' + index + '"]').classList;
  current.remove('hidden');
  current.add('active');
  
  // change details
  document.querySelectorAll('.details > div').forEach((img)=> {
    img.classList.remove('active');
    img.classList.add('hidden');
  });
  current = document.querySelector('.details > div[data-loc="' + index + '"]').classList;
  current.remove('hidden');
  current.add('active');

  // change heading
  document.querySelectorAll('.locations li').forEach((li)=> {
    li.classList.remove('active');
    li.classList.add('hidden');
  });
  current = document.querySelector('.locations li[data-loc="' + index + '"]').classList;
  current.remove('hidden');
  current.add('active');
  // change booking footer
}
